import { Union, Record } from "../../fable-library-js.4.19.0/Types.js";
import { union_type, list_type, lambda_type, tuple_type, record_type, string_type, bool_type, option_type, class_type } from "../../fable-library-js.4.19.0/Reflection.js";
import { utcNow } from "../../fable-library-js.4.19.0/Date.js";
import { englishUK, Localization_$reflection } from "../../Fable.Date.1.0.0/Date.Local.fs.js";
import { CSSProp, CSSProp_$reflection } from "../../Fable.React.9.4.0/Fable.React.Props.fs.js";
import { ofArray } from "../../fable-library-js.4.19.0/List.js";

export class State extends Record {
    constructor(Today, InputFocused, ReferenceDate, AutoClose, ForceClose, TitleFormat, ShowDeleteButton) {
        super();
        this.Today = Today;
        this.InputFocused = InputFocused;
        this.ReferenceDate = ReferenceDate;
        this.AutoClose = AutoClose;
        this.ForceClose = ForceClose;
        this.TitleFormat = TitleFormat;
        this.ShowDeleteButton = ShowDeleteButton;
    }
}

export function State_$reflection() {
    return record_type("Fulma.Elmish.DatePicker.Types.State", [], State, () => [["Today", option_type(class_type("System.DateTime"))], ["InputFocused", bool_type], ["ReferenceDate", class_type("System.DateTime")], ["AutoClose", bool_type], ["ForceClose", bool_type], ["TitleFormat", string_type], ["ShowDeleteButton", bool_type]]);
}

export const defaultState = new State(undefined, false, utcNow(), false, false, "", false);

export class Config$1 extends Record {
    constructor(OnChange, Local, DatePickerStyle) {
        super();
        this.OnChange = OnChange;
        this.Local = Local;
        this.DatePickerStyle = DatePickerStyle;
    }
}

export function Config$1_$reflection(gen0) {
    return record_type("Fulma.Elmish.DatePicker.Types.Config`1", [gen0], Config$1, () => [["OnChange", lambda_type(tuple_type(State_$reflection(), option_type(class_type("System.DateTime"))), gen0)], ["Local", Localization_$reflection()], ["DatePickerStyle", list_type(CSSProp_$reflection())]]);
}

export function defaultConfig(onChangeMsg) {
    return new Config$1(onChangeMsg, englishUK, ofArray([new CSSProp(291, ["absolute"]), new CSSProp(249, ["450px"])]));
}

export class Msg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NoOp"];
    }
}

export function Msg_$reflection() {
    return union_type("Fulma.Elmish.DatePicker.Types.Msg", [], Msg, () => [[]]);
}

export class Model extends Record {
    constructor(CurrentDate) {
        super();
        this.CurrentDate = CurrentDate;
    }
}

export function Model_$reflection() {
    return record_type("Fulma.Elmish.DatePicker.Types.Model", [], Model, () => [["CurrentDate", class_type("System.DateTime")]]);
}

//# sourceMappingURL=Types.fs.js.map
